import sendRequest from "../ppdNetwork/index.js";
// 未登录 接口
const unloginUrlMap = {
    // 链路曝光上报接口
    collect: '/metricsHome/statisData/collect',
    // apollo配置接口
    queryByList: '/xadadmin/config/queryByList',
};
// 已登录 接口
const urlMap = {
    // 链路曝光上报接口
    collect: '/metricsHome/statisDataUser/collect',
    // apollo配置接口
    queryByList: '/xadadmin/config/queryByList',
};
//读取cookies
function getCookie(name) {
    var arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) return arr[2];
    else return null;
};
export function sendCommonRequest(name, params = {}, method = 'post') {
    return sendRequest({
        method,
        url: getCookie('token') ? urlMap[name] : unloginUrlMap[name] || unloginUrlMap[name],
        params,
        showNetToast: false, // 网络异常toast
        showBusinessToast: false, // 业务异常toast
        showLoading: false, // loading
    });
}